import { Directive, inject } from '@angular/core';

import { LcpCandidateConfig } from '@frontend/sports/common/client-config-data-access';

/**
 *
 * @experimental
 *
 * @whatItDoes Makes the element eligible to be considered the largest contentful paint by adding an invisible svg as a
 * background image. For more information on what makes a candidate eligible to be largest contentful paint read the
 * official specs. {@link https://w3c.github.io/largest-contentful-paint/#sec-terminology|W3C Largest Contentful Paint}
 *
 */

@Directive({
    host: {
        '[class]': 'candidateClass',
    },
})
export class LcpCandidateDirective {
    #config = inject(LcpCandidateConfig);
    candidateClass = this.#config.isEnabled ? 'sports-sports-lcp-candidate' : null;
}
